/**
 * openHaspRuntimeVariables.js
 *
 * The `%…%` placeholders openHASP firmware substitutes on the plate when it
 * renders a text property. Lifted out of IconPicker.vue's `data()` (where
 * they were the String Builder's hardcoded Variables tab) so that "which
 * variables does this context have?" is a caller's answer rather than a
 * property of the builder.
 *
 * These are resolved by the firmware, in the plate's own text rendering —
 * so they are valid wherever a string reaches the device as a literal
 * (the Properties panel's `text` / `value_str`, an action's property
 * value), and NOT valid in a Home Assistant template: the HA component
 * renders Jinja and sends the result, and nothing in that path knows what
 * `%ip%` means. A binding editor therefore supplies its own list (see
 * StringBuilderField.vue / MappingBindingEditor.vue) instead of inheriting
 * this one.
 *
 * Source: https://www.openhasp.com/latest/design/objects/ ("Text
 * placeholders").
 *
 * @typedef {{ token: string, label?: string, description: string }} BuilderVariable
 */

/** @type {BuilderVariable[]} */
export const OPENHASP_RUNTIME_VARIABLES = [
  { token: '%ip%',       description: 'IP address of the plate' },
  { token: '%hostname%', description: 'Hostname (nodename)' },
  { token: '%ssid%',     description: 'SSID of the network connected to' },
  { token: '%model%',    description: 'Plate model (set in the firmware)' },
  { token: '%version%',  description: 'Firmware version number' },
];

export default OPENHASP_RUNTIME_VARIABLES;
